var $3002ef4536e67857$exports = {};
$3002ef4536e67857$exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};


export {$3002ef4536e67857$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
